import { LOADER_DEFAULT_MESSAGE } from '../../config/loader.config';

type Props = {
  /** Full-screen overlay (route lazy load) vs inline block */
  variant?: 'screen' | 'inline';
  /** Override text; defaults to LOADER_DEFAULT_MESSAGE */
  message?: string;
};

export default function TropaymentLoader({
  variant = 'inline',
  message = LOADER_DEFAULT_MESSAGE,
}: Props) {
  const screenClass = variant === 'screen'
    ? 'tropayment-loader-screen'
    : 'tropayment-loader-screen tropayment-loader-screen--inline';

  return (
    <div className={screenClass} role="status" aria-live="polite" aria-busy="true">
      <div className="tropayment-loader-container">
        <div className="tropayment-loader-wrap">
          <div className="tropayment-loader-ring" aria-hidden="true" />
          <div className="tropayment-loader-ring tropayment-loader-ring--inner" aria-hidden="true" />
          <div className="tropayment-loader-logo" aria-hidden="true">
            <span>T</span>
          </div>
        </div>
        <p className="tropayment-loader-text">
          {message}
          <span className="tropayment-loader-dots" aria-hidden="true" />
        </p>
      </div>
    </div>
  );
}
